import { PageHead } from '../components/ui';
import { OwnershipMap } from './dependency/OwnershipMap';

/**
 * Ownership Dependency Map.
 *
 * The map the standalone EOS app draws, brought across whole by request — see
 * `dependency/OwnershipMap.tsx` for what came with it and the three things
 * that could not come literally.
 *
 * WHAT THIS REPLACED. The page used to be a scored register: areas holding
 * items, each rated how dependent it is on one person against how much it
 * hurts when it stops, giving a 1-25 risk that ranked the list. That model is
 * NOT deleted — `coo.DependencyArea` and `coo.DependencyItem` still hold their
 * rows and the dashboard still reads them for its per-function risk figure —
 * it just is not what this page draws any more, and there is no longer a
 * screen that edits it. Deciding what becomes of that figure is a separate
 * call, deliberately deferred. See migration 082.
 */
export function DependencyPage() {
  return (
    <>
      <PageHead
        title="Ownership Dependency Map"
        lede="Everything the business depends on the owner for. One map, worked as a tree or as cards — both edit the same thing, and it saves as you go."
      />
      <OwnershipMap />
    </>
  );
}
